import {
  StudentsActivityMetricFilter,
  StudentsActivityMetricsResponse,
} from "@/reports/types";

export const studentsActivityMetricFilterMock: StudentsActivityMetricFilter = {
  min_date: "2023-08-01",
  max_date: "2024-07-08",
  entity_type: "classroom",
  entity_id: "26444e9518aa42d3a0837926262e6a5c",
  entity_filter_type: null,
  entity_grade_level: null,
  content_grade_level: null,
  only_assigned_content: false,
};

export const studentsActivityMetricsMock: StudentsActivityMetricsResponse = {
  data: {
    filters_applied: studentsActivityMetricFilterMock,
    data: {
      entities: [
        {
          reading_skills_covered: [
            {
              content_id: "string",
              text: "string",
            },
            {
              content_id: "skill2",
              text: "skill",
            },
          ],
          reading_session_date: "2023-09-01",
          annotations_submitted_count: 10,
          reading_session_time: 24,
          write_prompt_score: "Ungraded",
          article_lexile_level: "1040L",
          article_grade_level: 8,
          assignment_id: "asdf",
          article_content_id: "asdflkjd",
          article_header_content_id: "lksdjfldskfj",
          student_unique_id: "2895a5e673b045288160a98af7fd5a91",
          first_name: "John",
          last_name: "Wick",
          activities: {
            article_grade_level_viewed_average: 9,
            article_lexile_level_viewed_average: "1020L",
            articles_viewed_count: 9,
            article_time_average: 40,
            quizzes_completed_count: 5,
            quizzes_completed_score_average: 0.5,
            write_prompts_completed_count: 8,
            write_prompts_score_average: 0.5,
            annotations_avg_count_by_article: 10.2,
            powerwords_quiz_score_average: 0.8,
          },
        },
      ],
      total_items: 5,
    },
    debug_mode: null,
  },
};
